module.exports = __webpack_public_path__ + "static/notebook-recordings-creative-c788cfd93541dc30e68b69f389281455.png";